
<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
            <span class="mask bg-gradient-success opacity-8"></span>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                
                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">{{ this.$route.name }}</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <!-- <a href="#!" class="btn btn-sm btn-primary">Settings</a> -->
                                </div>
                            </div>
                        </div> 

                        <template>
                            <tabs fill class="flex-column flex-md-row">
                                <card shadow>
                                    <tab-pane title="Pending Applications">
                                        <span slot="title">
                                            <i class="ni ni-books"></i>
                                            Pending Applications
                                        </span>
                                        <!-- import Pending Old Aq template here -->
                                        <PendingOldAqs /> 
                                    </tab-pane>
                                        
                                    <tab-pane title="Approved Applications">
                                        <span slot="title">
                                            <i class="ni ni-archive-2"></i>
                                            Approved Applications
                                        </span>
                                        <!-- import Approved Old Aq template here -->
                                        <ApprovedOldAqs /> 
                                    </tab-pane>

                                    <tab-pane title="Rejected Applications">
                                        <span slot="title">
                                            <i class="ni ni-archive-2"></i>
                                            Rejected Applications
                                        </span>
                                        <!-- import Rejected Old Aq template here -->
                                        <RejectedOldAqs /> 
                                    </tab-pane>
                                    
                                </card>
                            </tabs>

                        </template>

                    </card>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
  import PendingOldAqs from './PendingOldAqs';
  import ApprovedOldAqs from './ApprovedOldAqs';
  import RejectedOldAqs from './RejectedOldAqs';

  export default {
    name: 'OldAddQualifications',
    components: {
        PendingOldAqs,
        ApprovedOldAqs,
        RejectedOldAqs
    }
  };
</script>
<style></style>
